import { createSlice } from "@reduxjs/toolkit";

export const emissionnormsSlice = createSlice({
  name: "emissionnorms",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    emissionnormslist: [],
    model: false,
    error_msg: null,
    listCount: 0,
    rowdata: {},
    emissionnormsParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getEmissionnorms: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    emissionnormsListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.emissionnormsParams.page_size
      );

      return {
        ...state,
        listCount: action.payload.response.count,
        emissionnormslist: action.payload.response.results,
        loading: false,
        emissionnormsParams: {
          ...state.emissionnormsParams,
          no_of_pages: noofpages,
        },
      };
    },
    emissionnormsAdd: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    emissionnormsAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    emissionnormsEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    emissionnormsEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    emissionnormsDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetEmissionnormsParams: (state, action) => {
      return {
        ...state,
        emissionnormsParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getEmissionnorms,
  emissionnormsListSuccessful,
  emissionnormsAdd,
  emissionnormsAddSuccessful,
  emissionnormsEdit,
  emissionnormsEditSuccessful,
  emissionnormsDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetEmissionnormsParams
} = emissionnormsSlice.actions;

export default emissionnormsSlice.reducer;
